const options = {
  removeItems: true,
  removeItemButton: true,
  resetScrollPosition: false,
  searchResultLimit: 100,
  loadingText: ``,
  noResultsText: 'Inga resultat',
  noChoicesText: 'Inga alternativ',
  itemSelectText: 'Klicka för att välja',
  addItemText: (value) => {
    return `Klicka för att välja <b>“${value}”</b>`;
  },
};

export default options;
